export default __webpack_public_path__ + "static/media/lb.897335ed.png";